import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import * as PublicationStore from './NonLinear/PublicationStore';
import * as PublicationLogStore from './NonLinear/PublicationLogStore';
import * as SMPACHeaderStore from './Controls/SMPACHeaderStore';
import * as PublicationRightsStore from './NonLinear/PublicationRightsStore';
import * as NonLinearStore from './NonLinear/NonLinearStore';
import { IsDevelopment } from '../constants';
import * as DeletedCuesStore from './Cuesheets/DeletedCuesStore';
import * as ProgrammeCategoryStore from './NonLinear/ProgrammeCategoryStore';
import * as AmendmentHistoryStore from './Cuesheets/AmendmentHistoryStore';
import * as CueHistoryStore from './Cues/CueHistoryStore';
import * as NonLinearFormStore from './NonLinear/NonLinearFormStore';
import * as Login from './Auth/LoginStore';
import * as EmailVerification from './Auth/EmailVerificationStore';
import * as Verification2FA from './Auth/Verification2FAStore';
import * as Gateway from './Auth/GatewayStore';
import * as UserStore from './User/UserStore';

export default function configureStore(history, initialState) {
    const reducers = {
        publication: PublicationStore.reducer,
        publicationLog: PublicationLogStore.reducer,
        smpacHeader: SMPACHeaderStore.reducer,
        publicationRights: PublicationRightsStore.reducer,
        deletedCues: DeletedCuesStore.reducer,
        programmeCategory: ProgrammeCategoryStore.reducer,
        cueHistory: CueHistoryStore.reducer,
        nonLinear: NonLinearStore.reducer,
        nonLinearForm: NonLinearFormStore.reducer,
        amendmentHistory: AmendmentHistoryStore.reducer,
        login: Login.reducer,
        emailVerification: EmailVerification.reducer,
        verification2FA: Verification2FA.reducer,
        gateway: Gateway.reducer,
        userStore: UserStore.reducer
    };

    const middleware = [
        thunk,
        routerMiddleware(history)
    ];

    // In development, use the browser's Redux dev tools extension if installed
    const enhancers = [];

    if (IsDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
        enhancers.push(window.devToolsExtension());
    }

    const rootReducer = combineReducers({
        ...reducers,
        routing: routerReducer
    });

    return createStore(
        rootReducer,
        initialState,
        compose(applyMiddleware(...middleware), ...enhancers)
    );
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js